require('./dist/angular-filter.js');
module.exports = 'angular.filter';



//////////////////
// WEBPACK FOOTER
// ./~/angular-filter/index.js
// module id = 342
// module chunks = 2